import axios from 'axios';

export default {
  async fetchIncidents({ commit }) {
    try {
      commit('setLoading', true);
      commit('setError', null);

      const response = await axios.get('/status/incidents');
      commit('setActiveIncidents', response.data.active);
      commit('setResolvedIncidents', response.data.resolved);
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Erro ao carregar incidentes');
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  async fetchEndpoints({ commit }) {
    try {
      commit('setLoading', true);
      commit('setError', null);

      const response = await axios.get('/status/endpoints');
      commit('setEndpoints', response.data);
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Erro ao carregar endpoints');
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },
};
